<template>
  <label
    v-if="!blocked"
    class="crlv-capture-toggle"
    :title="tooltipText"
    @click.stop
  >
    <input
      type="checkbox"
      :checked="isOn"
      :disabled="disabled"
      @click.prevent="$emit('request-toggle', { vehicle, action: pendingAction })"
    >
    <span class="slider"></span>
  </label>
</template>

<script>
  import { crlvCaptureActive, vehicleHasSne } from '@/utils/crlvHelp'

  export default {
    name: 'CrlvCaptureToggle',
    props: {
      vehicle: { required: true, type: Object },
      disabled: { default: false, type: Boolean }
    },
    computed: {
      summary() {
        return this.vehicle.crlvSummary || null
      },
      isActive() {
        return crlvCaptureActive(this.summary)
      },
      isCaptured() {
        return !!this.summary && !!this.summary.document_id && this.summary.licensing_status !== 'expired'
      },
      isOn() {
        return this.isActive
      },
      blocked() {
        return this.isCaptured || (!this.isActive && !vehicleHasSne(this.vehicle))
      },
      pendingAction() {
        if (this.isActive)
          return 'cancel'

        return this.isCaptured ? 'captured' : 'activate'
      },
      tooltipText() {
        if (this.isActive)
          return 'Desativar captura do CRLV'

        if (this.isCaptured)
          return 'CRLV do exercício atual já anexado'

        return this.blocked ? 'Habilite o SNE deste veículo para capturar o CRLV' : 'Ativar captura do CRLV'
      }
    }
  }
</script>

<style scoped lang="scss">
  .crlv-capture-toggle {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 22px;
    margin: 0 6px 0 0;
    vertical-align: middle;
    cursor: pointer;

    input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #ccc;
      transition: .3s;
      border-radius: 22px;

      &:before {
        position: absolute;
        content: "";
        height: 16px;
        width: 16px;
        left: 3px;
        bottom: 3px;
        background-color: white;
        transition: .3s;
        border-radius: 50%;
      }
    }

    input:checked + .slider {
      background-color: #1ab394;
    }

    input:checked + .slider:before {
      transform: translateX(18px);
    }

    input:disabled + .slider {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
</style>
